import { Component, EventEmitter, HostBinding, HostListener, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FileInfo } from '../souscription-file-items.component';
import { OuiFileUploader } from 'omnium-ui/file-uploader';
import { MatDialog } from '@angular/material/dialog';
import {
  AddUploadDocumentViewerComponent,
  AddUploadResult,
} from '@lib/components/pdf-viewer/add-upload/add-upload-document-viewer.component';
import { DraftOperationsService } from 'src/service/draft-operation/draft-operation.service';
import { OutdatedOperationDocument } from '@lib/models/generated/graphql';

export interface AddLocalFileResult {
  files: File[];
  applyToAllOperations: boolean | undefined;
}

@Component({
    selector: 'app-souscription-file-item',
    templateUrl: './souscription-file-item.component.html',
    styleUrls: ['./souscription-file-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SouscriptionFileItemComponent {
  @Input()
  itemsCategory: 'operation' | 'investisseur' | 'co-investisseur' | 'conseil' = 'operation';

  @Input({ required: true })
  fileInfo: FileInfo;

  @Input({ required: true })
  isFileLoading: boolean = false;

  @Input()
  outdatedDocument?: OutdatedOperationDocument;

  @Output()
  addFileClick = new EventEmitter<AddLocalFileResult>();

  @Output()
  addFromInvestisseurDocs = new EventEmitter();

  @Output()
  fileSelected = new EventEmitter();

  @Output()
  refreshOutdatedDocument = new EventEmitter<Event>();

  @HostBinding('class.selectable')
  get isSelectable(): boolean {
    return this.fileInfo.missingState === 'notMissing';
  }
  get isCoInvestisseur(): boolean {
    return !!this.fileInfo.fichierOperation?.estCoInvestisseur;
  }
  @HostListener('click')
  onClick() {
    if (!this.isSelectable) return;
    this.fileSelected.emit();
  }

  files: File[] = [];

  private openViewerOnNextSelection = false;

  constructor(private dialog: MatDialog, private draftOperationService: DraftOperationsService) {}

  deleteFile(file: File) {
    this.files = this.files.filter(f => f !== file);
  }

  onFilesChange(files: File[] | null) {
    if (!files || files.length === 0) {
      this.openViewerOnNextSelection = false;
      return;
    }
    this.files = files;

    if (this.openViewerOnNextSelection) {
      this.openViewerOnNextSelection = false;

      const dialogRef = this.dialog.open(AddUploadDocumentViewerComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
        panelClass: 'full-screen-modal',
        autoFocus: false,
        data: {
          files,
          natureDocumentRequi: this.fileInfo.fichierOperation?.natureDocumentRequis ?? undefined,
          typeSelectable: true,
          investisseurs: [],
          multiple: false,
          showAllOperationsOption:
            this.draftOperationService.operationGroupData.operations.length > 1 && this.itemsCategory === 'operation',
        },
      });
      dialogRef.afterClosed().subscribe((result: AddUploadResult) => {
        if (!result) {
          return;
        }
        let forAllope = result.forAllOperations;
        this.addFileClick.emit({ files: this.files, applyToAllOperations: forAllope });
      });
    } else {
      this.addFileClick.emit({ files: this.files, applyToAllOperations: false });
    }
  }

  openPicker(uploader: OuiFileUploader) {
    this.openViewerOnNextSelection = true;
    uploader.openFileDialog();
  }
}
